import apiClient from '../client'

export const licenseService = {
  get: async () => {
    const response = await apiClient.get('/license')
    return response.data.license
  },

  regenerate: async () => {
    const response = await apiClient.post('/license/regenerate')
    return response.data.license
  },

  removeActivation: async (activationId) => {
    await apiClient.delete(`/license/activations/${activationId}`)
    return true
  },
}
